import React from 'react';
import 'twin.macro';
import { useGetPlans } from 'queries/plan/useGetPlans';
import { queryClient } from 'queryClient';
import { loader as billingInfoLoader } from 'queries/useBillingInfos';
import { PageTrackerWrapper } from 'queries/user/track';
import ChoosePlanPage from 'containers/Pricing/ChoosePlanPage';
import ThankYou from 'containers/ThankYou/Loadable';
// import { TeetshBackground } from 'components/TeetshBackground';
import AddressPage from 'containers/Pricing/AddressPage/Loadable';
import PaymentPage from 'containers/Pricing/PaymentPage/Loadable';
import { Outlet } from 'react-router-dom';
import { RedeemPage } from 'containers/Pricing/RedeemPage';
import SpinnerComponent from 'components/Spinner/ScreenSpinner';
import { SingleCardPage } from 'components/Layouts/SingleCardPage';
import { PricingPageWrapper } from './PricingPageWrapper';

function SubscriptionWrapper() {
  const { data, isLoading } = useGetPlans();
  const plans = data || [];
  if (isLoading) {
    return <SpinnerComponent />;
  }
  return <Outlet context={{ plans }} />;
}

export const PricingRoutes = [
  {
    path: 'pricing',
    children: [
      {
        index: true,
        loader: billingInfoLoader(queryClient),
        element: (
          <PageTrackerWrapper title="Tarifs">
            <ChoosePlanPage />
          </PageTrackerWrapper>
        ),
      },
    ],
  },
  {
    path: 'redeem-license',
    element: (
      <PageTrackerWrapper title="Redeem license">
        <RedeemPage />
      </PageTrackerWrapper>
    ),
  },
  {
    path: 'thank-you',
    element: (
      <PageTrackerWrapper title="Thank you">
        <ThankYou />
      </PageTrackerWrapper>
    ),
  },
  {
    path: 'subscription',
    element: <SubscriptionWrapper />,
    children: [
      {
        path: 'address',
        loader: billingInfoLoader(queryClient),
        element: (
          <PageTrackerWrapper title="Tarifs - adresse">
            <PricingPageWrapper onPrev={-2}>
              <SingleCardPage tw="w-full" maxWidth="md" lightPadding withMargin>
                <AddressPage />
              </SingleCardPage>
            </PricingPageWrapper>
          </PageTrackerWrapper>
        ),
      },
      {
        path: 'checkout',
        loader: billingInfoLoader(queryClient),
        element: (
          <PageTrackerWrapper title="Tarifs - paiement">
            <PricingPageWrapper onPrev={-3}>
              <SingleCardPage
                tw="w-full"
                maxWidth="responsive"
                lightPadding
                withMargin
              >
                <PaymentPage />
              </SingleCardPage>
            </PricingPageWrapper>
          </PageTrackerWrapper>
        ),
      },
    ],
  },
];
